import classNames from 'classnames';
import Icon from '/@/components/icon';
import { isMobile } from '/@/utils';

import NOLItemListStyles from '../item-list/styles.module.css';
import styles from './styles.module.css';

const NOLHeader = ({ overlayConfig, goBack }) => {
    return (
        <div className={styles.header}>
            <div className={styles.title}>
                <Icon
                    className={classNames(styles.overlayIcon, styles[`icon-color-${overlayConfig.color}`])}
                    type={overlayConfig.icon}
                    size='xxl'
                />
                <div
                    className={classNames(
                        styles.label,
                        styles[`color-${overlayConfig.color}`],
                        NOLItemListStyles.label,
                        NOLItemListStyles[`color-${overlayConfig.color}`]
                    )}
                >
                    {overlayConfig.label}
                </div>
            </div>
            {goBack && !isMobile() && (
                <Icon type='arrow' size='xs' className={styles.goBack} onClick={() => goBack()} />
            )}
        </div>
    );
};

export default NOLHeader;
